import { Card, CardContent, Typography } from '@mui/material';
import React from 'react';
import { Datagrid, FunctionField, ReferenceManyField, TextField } from 'react-admin';
import { Link } from 'react-router-dom';


interface BillingAccountProjectsProps {
  billingAccount: any;
}

export const BillingAccountProjects:React.FC<BillingAccountProjectsProps> = ({billingAccount}) => {

  return (

    <Card>
    <CardContent>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
        <Typography variant="h6" gutterBottom>
          Projects
        </Typography>
      </div>

      <ReferenceManyField
        label="Projects"
        reference="projects"
        target="billingAccountId"
      >
        <Datagrid bulkActionButtons={false}>
          <FunctionField
            label="Project"
            render={(record: any) => (
              <Link to={`/projects/${record.id}`}>{record.name}</Link>
            )}
          />
          <TextField source="folderId" label="Folder ID" />
          <TextField source="destination" label="Destination" />
          <TextField source="status" label="Status" />
        </Datagrid>
      </ReferenceManyField>
    </CardContent>
  </Card>
)};

